import Stats from './Stats'

export default [{
  path: '/stats',
  name: 'Stats',
  component: Stats,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Stats'}
}
/*, {
  path: '/project/:id',
  name: 'ProjectDetails',
  component: ProjectDetails,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll'}
}*/
]



// WEBPACK FOOTER //
// ./src/pages/stats/router.js